import BftButton from "common/components/button";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import Footer from "layout/components/footer";
import Sidebar from "layout/components/sidebar";
import Topbar from "layout/components/topbar";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface StepCardProps {
	icon: string;
	title: string;
	stepNumber: number;
}

const title = "Attiva i nostri servizi di pagamento in 4 passaggi";
const firstSubtitle =
	"Segui le istruzioni riportate qui sotto e assicurati di avere tutti i documenti necessari.";
const secondSubtitle =
	"Qualora fossi in difficoltà non esitare a contattarci, il nostro servizio clienti è a disposizione.";

const steps = [
	{
		icon: "fa-shop",
		title: "Inserisci i tuoi dati aziendali.",
	},
	{
		icon: "fa-user-group",
		title: "Inserisci i tuoi dati anagrafici.",
	},
	{
		icon: "fa-square-plus",
		title: "Seleziona uno o più servizi.",
	},
	{
		icon: "fa-file-signature",
		title: "Identificati e firma il contratto",
	},
];

const StartPage: React.FC = () => {
	const navigate = useNavigate();

	const goNext = () => {
		navigate(AppRouterService.get(PathEnum.requirements));
	};

	return (
		<>
			<Sidebar />
			<div className="wrapper d-flex flex-column min-vh-100">
				<div className="body flex-grow-1 px-0">
					<Topbar />
					<div className="container-fluid pre-step-body px-0">
						<div className="text-center">
							<header className="App-header">
								<h2 className="mb-3">{title}</h2>
								<span className="gray">{firstSubtitle}</span>
								<span className="gray">{secondSubtitle}</span>

								<Row xs={1} sm={2} md={4} className="my-4 mx-2">
									{steps.map((step, index) => (
										<StepCard
											key={index}
											icon={step.icon}
											title={step.title}
											stepNumber={index + 1}
										/>
									))}
								</Row>

								<BftButton className="btn-buffetti" onClick={goNext}>
									Inizia subito!
								</BftButton>
							</header>
						</div>
					</div>
				</div>
				<Footer />
			</div>
		</>
	);
};

const StepCard = (props: StepCardProps) => {
	const { icon, title, stepNumber } = props;
	return (
		<Col>
			<Card className="shadow min-size-card">
				<Card.Body>
					<div className="d-flex flex-column">
						<div className="square-icon-shadow icon-card">
							<div className="square-icon-container">
								<i className={`fas ${icon} square-icon`}></i>
							</div>
						</div>
						<div className="text-left pt-1">
							<span className="gray font-weight-bold m-0">
								<small>STEP {stepNumber}</small>
							</span>
							<h6>{title}</h6>
						</div>
					</div>
				</Card.Body>
			</Card>
		</Col>
	);
};

export default StartPage;
